export default function EFPhone(props: any) {
    return (
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="phone_icon">
                    <rect id="矩形" x="0" y="0" width="30" height="30"></rect>
                    <g id="编组" transform="translate(7.000000, 1.968502)" stroke="#FFFFFF">
                        <ellipse
                            id="椭圆形"
                            strokeWidth="0.575539568"
                            fill="#FFFFFF"
                            fillRule="nonzero"
                            cx="8"
                            cy="23.4619109"
                            rx="1.08856229"
                            ry="1.09117902"
                        ></ellipse>
                        <line x1="6.31435693" y1="2.17049981" x2="9.68564305" y2="2.17049981" id="路径-3" strokeLinecap="round" strokeLinejoin="round"></line>
                        <path
                            d="M2.17665622,0 L13.8233438,0 C15.0254778,-1.28853795e-15 16,0.974522182 16,2.17665622 L16,23.9426226 C16,25.1447567 15.0254778,26.1192789 13.8233438,26.1192789 L2.17665622,26.1192789 C0.974522182,26.1192789 5.91308169e-16,25.1447567 0,23.9426226 L0,2.17665622 C-1.4721896e-16,0.974522182 0.974522182,6.64917649e-16 2.17665622,0 Z"
                            id="矩形"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
